import { render, staticRenderFns } from "./Dispositivo.vue?vue&type=template&id=44a26450&"
import script from "./Dispositivo.vue?vue&type=script&lang=ts&"
export * from "./Dispositivo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('44a26450', component.options)
    } else {
      api.reload('44a26450', component.options)
    }
    module.hot.accept("./Dispositivo.vue?vue&type=template&id=44a26450&", function () {
      api.rerender('44a26450', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/Dispositivo.vue"
export default component.exports